import React , {Component} from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import HmEventRegistry from '../../model/HmEventRegistry';

class DropdownLayout extends Component{

    constructor(props){
        super(props);
        this.state={
            dropdownOpen:false,
            data : props.data,
            dataList:null,
            tick:false
        }
        this.toggle = this.toggle.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
    }

    componentDidMount(){
       this.setState({data:this.props.data || []})
       //console.log("dropdwn data ",this.props.data);
       HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
    }

    optionClick(value,e){
        e.target.value = value;
        //console.log("option clicked ",value);
        this.setState(prevState => ({
            tick:!prevState.tick
        }))

        if(typeof this.props.event === "function"){
            this.props.event(value);
        }
    }

    createSelectItems(){
        let tickShow =  (this.props.tick ==  false) ? false : true;
        let tick = this.state.tick ? "done":"done";
        let tickCls = tick == "done" ? "success" : "";
        if(tick){
            
        }
        
        if(this.props.data!=null){
            return (<DropdownItem>
                {
                    this.props.data.map((col,index)=>{
                        //console.log("col data",col.disabled);
                        let active =  (col.active) ? "" : " disabled";
                        return(
                            <div key={index} className={"dd-option"+active} data-ga={"more options -" + col.name }>
                             
                                <option key={index} value={col.name} onClick={this.optionClick.bind(this,col.name)}>  {col.name} </option>
                                   </div>
                            )
                         })
                }
                </DropdownItem>
            )
        }
    } 
    
    toggle() {
        this.setState(prevState => ({
        dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render(){
        let icon = this.props.icon || "filter_list";
        return(
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
            <DropdownToggle>
                <i className="material-icons filter-icon">{icon}</i>
            </DropdownToggle>
            <DropdownMenu>
            {this.createSelectItems()}
            </DropdownMenu>
            </Dropdown>  
        )
    }
}

export default DropdownLayout;


// WEBPACK FOOTER //
// ./src/views/registration/DropdownLayout.js